import { useState } from "react";

export default function UserAvatar({ user, onClick }) {
  const [imgError, setImgError] = useState(false);

  // const avatarUrl =
  //   !imgError && user?.avatarUrl
  //     ? user.avatarUrl
  //     : `https://api.dicebear.com/7.x/initials/svg?seed=${
  //         user?.preferredName || "User"
  //       }`;
  const avatarUrl = !imgError && user?.avatarUrl ? user.avatarUrl : null;

  return (
    <div
      onClick={onClick}
      className="bg-[transparent] rounded-full flex items-center justify-center font-bold text-white overflow-hidden cursor-pointer"
    >
      {avatarUrl ? (
        <img
          src={avatarUrl}
          alt="User Avatar"
          onError={() => setImgError(true)}
          className="w-full h-full object-cover"
        />
      ) : (
        <div className="w-[36px] h-[36px] bg-[#e8e8e8] rounded-full flex items-center justify-center mr-2">
          <span className="font-sans text-[16px] text-[#565656] font-semibold leading-[24px]">
            {user.firstName && user.firstName.charAt(0).toUpperCase()}
            {user.lastName && user.lastName.charAt(0).toUpperCase()}
          </span>
        </div>
      )}
    </div>
  );
}
